class MultiColumnSection extends HTMLElement {
  static get observedAttributes() {
    return [
      'title', 'heading-size', 'image-width', 'image-ratio', 'columns-desktop', 'column-alignment', 
      'background-style', 'button-label', 'button-link', 'color-scheme', 'columns-mobile', 
      'swipe-on-mobile', 'padding-top', 'padding-bottom'
    ];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  attributeChangedCallback() {
    this.render();
  }

  connectedCallback() {
    this.render();
  }

  getColumnsData() {
    const columns = Array.from(this.children).filter(el => el.tagName.toLowerCase() === 'multi-column-section-column' || el.getAttribute('data-is') === 'multi-column-section-column');
    return columns.map(col => {
      return {
        image: col.getAttribute('image') || '',
        title: col.getAttribute('title') || '',
        text: col.innerHTML.trim(),
        linkLabel: col.getAttribute('link-label') || '',
        link: col.getAttribute('link') || ''
      };
    });
  }

  render() {
    const title = this.getAttribute('title') || '';
    const headingSize = this.getAttribute('heading-size') || 'h1';
    const imageWidth = this.getAttribute('image-width') || 'full';
    const imageRatio = this.getAttribute('image-ratio') || 'adapt';
    const columnsDesktop = parseInt(this.getAttribute('columns-desktop') || '3', 10);
    const columnAlignment = this.getAttribute('column-alignment') || 'left';
    const backgroundStyle = this.getAttribute('background-style') || 'primary';
    const buttonLabel = this.getAttribute('button-label') || '';
    const buttonLink = this.getAttribute('button-link') || '';
    const colorScheme = this.getAttribute('color-scheme') || 'scheme-1';
    const columnsMobile = parseInt(this.getAttribute('columns-mobile') || '1', 10);
    const swipeOnMobile = this.getAttribute('swipe-on-mobile') === 'true';
    const paddingTop = parseInt(this.getAttribute('padding-top') || '36', 10);
    const paddingBottom = parseInt(this.getAttribute('padding-bottom') || '36', 10);

    const columns = this.getColumnsData();

    const showMobileSlider = swipeOnMobile && columns.length > columnsMobile;
    const highestRatio = 1; // ダミーのアスペクト比

    const styleTag = `
      <style>
        :host {
          display: block;
        }
        .section-padding {
          padding-top: ${Math.round(paddingTop)}px;
          padding-bottom: ${Math.round(paddingBottom)}px;
        }
        @media screen and (min-width: 750px) {
          .section-padding {
            padding-top: ${paddingTop}px;
            padding-bottom: ${paddingBottom}px;
          }
        }
        /* このstyleTagは必要に応じて最小限に留め、基本スタイルは外部CSSに任せます */
      </style>
    `;

    const titleHtml = title ? `<div class="title-wrapper-with-link multicolumn__title"><${headingSize} class="title">${title}</${headingSize}></div>` : '';

    const columnsHtml = columns.map((col, index) => {
      const isEmpty = !col.image && !col.title && !col.text && !col.linkLabel;
      const emptyClass = isEmpty ? ' multicolumn-list__item--empty' : '';
      const imageHtml = col.image ? `
        <div class="multicolumn-card__image-wrapper multicolumn-card__image-wrapper--${imageWidth}-width">
          <div class="media media--transparent media--${imageRatio}">
            <img src="${col.image}" class="multicolumn-card__image" alt="" />
          </div>
        </div>
      ` : '';
      const titleBlock = col.title ? `<h3>${col.title}</h3>` : '';
      const textBlock = col.text ? `<div class="rte">${col.text}</div>` : '';
      const linkBlock = col.linkLabel ? `<a class="link" ${col.link ? `href="${col.link}"` : 'role="link" aria-disabled="true"'}>${col.linkLabel}</a>` : '';

      return `
        <li class="multicolumn-list__item ${columnAlignment}${emptyClass}">
          <div class="multicolumn-card content-container">
            ${imageHtml}
            <div class="multicolumn-card__info">
              ${titleBlock}
              ${textBlock}
              ${linkBlock}
            </div>
          </div>
        </li>
      `;
    }).join('');

    const buttonHtml = buttonLabel ? `<a class="button button--primary" ${buttonLink ? `href="${buttonLink}"` : 'role="link" aria-disabled="true"'}>${buttonLabel}</a>` : '';

    this.shadowRoot.innerHTML = `
      <link href="//bizenya.co.jp/cdn/shop/t/59/assets/base.css?v=159841507637079171801728765943" rel="stylesheet" type="text/css" media="all" />
      <link href="//bizenya.co.jp/cdn/shop/t/59/assets/section-multicolumn.css?v=81420361875458722681728765946" rel="stylesheet" type="text/css" media="all" />
      <link href="//bizenya.co.jp/cdn/shop/t/59/assets/component-slider.css?v=14039311878856620671728765944" rel="stylesheet" type="text/css" media="all" />
      ${styleTag}
      <div class="multicolumn color-${colorScheme} background-${backgroundStyle} ${!title ? 'no-heading' : ''}">
        <div class="page-width section-padding">
          ${titleHtml}
          <slider-component class="slider-mobile-gutter">
            <ul class="multicolumn-list contains-content-container grid grid--${ columnsMobile }-col-tablet-down grid--${ columnsDesktop }-col-desktop slider slider--tablet grid--peek">
              ${columnsHtml}
            </ul>
          </slider-component>
          <div class="center">
            ${buttonHtml}
          </div>
        </div>
      </div>
    `;
/*
    // 外部CSSファイルの読み込み
    const linkEl = document.createElement('link');
    linkEl.setAttribute('rel', 'stylesheet');
    linkEl.setAttribute('href', 'section-multicolumn.css');
    this.shadowRoot.insertBefore(linkEl, this.shadowRoot.firstChild);
*/
  }
}

class MultiColumnSectionColumn extends HTMLElement {
  static get observedAttributes() {
    return ['image', 'title', 'link-label', 'link'];
  }
  constructor() {
    super();
  }
}

customElements.define('multi-column-section', MultiColumnSection);
customElements.define('multi-column-section-column', MultiColumnSectionColumn);
